import styled from 'styled-components';

export const StepImportantIcon = styled.span`
  font-size: ${({ theme }) => theme.fonts.text16Bold};
  color: ${({ theme }) => theme.colors.danger};
  padding-left: 4px;
`;
